<template>
  <div class="father">
    <div class="search-top">
      按日期查询卷：
      <el-date-picker @change="datePickerChange" v-model="search_data.time" type="daterange" align="right" unlink-panels
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
      </el-date-picker>
    </div>
    <!-- 表格部分 -->
    <div class="table-body">
      <el-table :data="coupon_list" border stripe style="width: 300px" height="520px"
        :header-cell-style="{ background: '#f5f7fa', color: '#1f2d3d', fontWeight: 'bold' }"
        :cell-style="{ padding: '12px 0' }">

        <!-- 券编号 -->
        <el-table-column prop="coupon_no" label="券编号" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="font-family: monospace; font-size: 13px;">{{ scope.row.coupon_no }}</span>
          </template>
        </el-table-column>

        <!-- 券名称 -->
        <el-table-column prop="coupon_name" label="券名称" min-width="140">
          <template slot-scope="scope">
            <strong>{{ scope.row.coupon_name }}</strong>
          </template>
        </el-table-column>

        <!-- 优惠类型 / 折扣信息 (根据discount 和 amount展示) -->
        <el-table-column prop="discount_info" label="优惠内容" min-width="130">
          <template slot-scope="scope">
            <span class="discount-tag">
              <span v-if="scope.row.discount == '1'"> {{ scope.row.amount }}元现金券</span>
              <span v-else-if="scope.row.discount == '2'"> {{ scope.row.amount }}折券</span>
              <span v-else> {{ scope.row.amount }}元券</span>
            </span>
          </template>
        </el-table-column>
        <!-- 状态 (基于status字段 0=有效 1=失效等) -->
        <el-table-column prop="status_label" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <span :class="['status-badge', scope.row.status == '0' ? 'status-active' : 'status-inactive']">
              {{ scope.row.status == '1' ? '已审核' : scope.row.status == '0' ? '待审核' : scope.row.status == '2' ? '启用' :
                scope.row.status == '-1' ? '删除' : '未知' }}
            </span>
          </template>
        </el-table-column>
        <!-- 发卷方式 -->
        <el-table-column prop="channer_no" label="发卷方式" min-width="250">
          <template slot-scope="scope">
            <div>{{ formatChannel(scope.row.distribution_channel_no) }} </div>
          </template>
        </el-table-column>
        <!-- 使用门槛 -->
        <el-table-column prop="require_info" label="使用门槛" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.amount_require != '0' && scope.row.amount_require">
              满 {{ scope.row.amount_require }} 元可用
            </span>
            <span v-else-if="scope.row.qty_require != '0' && scope.row.qty_require">
              满 {{ scope.row.qty_require }} 件可用
            </span>
            <span v-else-if="scope.row.both_require == 'True'">
              金额 & 数量同时满足
            </span>
            <span v-else>无门槛</span>
          </template>
        </el-table-column>

        <!-- 有效期 -->
        <el-table-column prop="valid_period" label="有效期" min-width="250">
          <template slot-scope="scope">
            <div>开始日期：{{ formatDate(scope.row.start_time) }} </div>
            <div>截止日期：{{ formatDate(scope.row.expire_time) }}</div>
          </template>
        </el-table-column>

        <!-- 发行/领取状态 -->
        <el-table-column prop="stock_info" label="库存/领取" min-width="140" align="center">
          <template slot-scope="scope">
            <div>总发行: {{ scope.row.total_quantity }}</div>
            <div style="font-size:12px; color:#909399;">已领: {{ scope.row.claim_quantity }} / 已发: {{
              scope.row.issue_quantity
            }}</div>
          </template>
        </el-table-column>

        <!-- 每人限领/每日限领 -->
        <el-table-column prop="limits" label="领取限制" min-width="130">
          <template slot-scope="scope">
            <div>每人限领: {{ scope.row.max_claim_quantity }}</div>
            <div>每日限领: {{ scope.row.day_claim_quantity }}</div>
            <div v-if="scope.row.max_use_quantity != '1'">最多使用: {{ scope.row.max_use_quantity }}</div>
          </template>
        </el-table-column>

        <!-- 适用范围（简略显示） -->
        <el-table-column prop="scope_info" label="适用范围" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.branch_scope_display"> 门店: {{ scope.row.branch_scope_display }}</span>
            <span v-if="scope.row.goods_scope_display && scope.row.goods_scope_display != '全品类'"> 商品: {{
              scope.row.goods_scope_display }}</span>
            <span v-if="!scope.row.branch_scope_display && !scope.row.goods_scope_display">全场通用</span>
          </template>
        </el-table-column>

        <!-- 备注 -->
        <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="remark-text">{{ scope.row.remark || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row, 'update')" :disabled="scope.row.status != '0'" type="text"
              size="small">修改</el-button>
            <el-button @click="handleClick(scope.row, 'audit')" :disabled="scope.row.status != '0'" type="text"
              size="small">审核</el-button>
            <el-button @click="handleClick(scope.row, 'disable')" :disabled="scope.row.status != '1'" type="text"
              size="small">禁用</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="empty-block"></div>
    <div class="empty-block"></div>
    <div class="empty-block"></div>
    <div class="empty-block"></div>
    <div class="empty-block"></div>
    <div class="empty-block"></div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapMutations } from "vuex";
import { timeFun, GetDateTime, showDialog } from "@/js/public";
import { mchCouponList, getListDistributionChannels, couponAudit, couponStop } from '@/api/coupon/coupon.js';
import { formatMoney } from "../js/couponInfo.js";
export default {
  data() {
    return {
      search_data: {//顶部搜索
        time: []
      },
      channel_options: [], //所有发卷通道
      coupon_list: [], //显示的卷列表
      all_coupon_list: [], //所有的卷列表
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  mounted() {
    this.getChannerl();
    this.getSevenDayCoupon();
  },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS", "CLEARTABS", "ADDTABS"]),
    async getChannerl() {
      this.channel_options = await getListDistributionChannels();
    },
    getSevenDayCoupon() {
      const expire_time = timeFun('', new Date()) + " 23:59:59";
      const start_time = GetDateTime(-7, new Date(), 'date') + " 00:00:00";
      this.search_data.time = [start_time, expire_time]
      this.getTicketLit(start_time, expire_time);
    },
    /**
     * 返回对应的channel_no
     * @param channel_no 
     */
    formatChannel(channel_no) {
      let channel = this.channel_options.find((item) => { return item.channel_no === channel_no });
      if (channel) {
        return channel.channel_name;
      } else {
        return "发卷方式未知"
      }
    },

    /**
     * 点击操作按钮
     * @param {object} 行
     * @param {"update"|"audit"|"disable"} key 需要执行的操作
     */
    async handleClick(row, key) {
      console.log(row)
      if (key === "update") {
        this.UPDATEMENUTABS("/couponForm");
        console.log("temp_data", this.temp_data);
        this.$router.push({ name: 'couponForm', params: { key: 'update', value: JSON.stringify(row) } });

        this.ADDTABS({
          activePath: "/couponForm",
          title: "优惠券详情"
        });
        return;
      }
      if (key === "audit") {
        const result = await couponAudit(row.coupon_no);
        console.log("返回值：", result);
        if (result.state === true) {
          this.successMessage("卷审核成功!");
          if (this.search_data.time.length > 0) {
            this.datePickerChange();
          } else { this.getSevenDayCoupon(); }

        }
        return;
      }
      if (key === "disable") {
        const disableRes = await couponStop(row.coupon_no);
        console.log("返回值：", disableRes);
        if (disableRes.state === true) {
          this.successMessage("卷审停用成功!");
          if (this.search_data.time.length > 0) {
            this.datePickerChange();
          } else { this.getSevenDayCoupon(); }

        }
        return;
      }


    },
    /**
     * 格式化时间
     * @param time 
     */
    formatDate(time) {
      return timeFun("eng", time);
    },
    /**
     * 格式化金额
     * @param count 
     */
    /* formatAmount(data) {
      console.log("11111111111111111", formatMoney(data, "create"));
      return 1
    }, */
    /**
     * 日期选择组件返回
     * @param e 
     */
    datePickerChange(e) {
      /* console.log(e);
      console.log("this.search_data.start_time", this.search_data.start_time); */
      this.getTicketLit(this.search_data.time[0], this.search_data.time[1]);
    },
    async getTicketLit(start, end) {
      this.all_coupon_list = await mchCouponList(timeFun("eng", start), timeFun("eng", end));
      for (let i = 0; i < this.all_coupon_list.length; i++) {
        this.all_coupon_list[i] = formatMoney(this.all_coupon_list[i], "create")
      }
      this.coupon_list = this.all_coupon_list;
    }
  }
}
</script>
<style lang="less" scoped>
.father {
  width: 100%;
  height: 99%;
  margin: 0px;
  display: flex;
  flex-direction: column;
  background-color: transparent !important;
}

.table-body {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 30px;
}

.search-top {
  width: 100%;
  height: 60px;
  min-height: 60px;
  margin-bottom: 15px;
  background-color: #fff;
  display: flex;
  justify-content: left;
  align-content: center;
  align-items: center;
  padding: 0 20px;
  border-radius: 10px;
}

.el-form-class {
  height: 80px;
  justify-content: left;
  padding-left: 20px;
}

/deep/.el-table__cell {
  right: 10px;
}
</style>